module.exports = "//public.zight.com/packs/media/images/icons-new-transparent-957765f9f06c5032180cbd50f9d4a031.svg";